import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {HashLink as ReactRouterLink, NavHashLink as NavLink} from 'react-router-hash-link';
import {generateRoutePath} from '@epic-core/common';

class Link extends PureComponent {
    static propTypes = {
        activeClassName: PropTypes.string,
        ariaLabel: PropTypes.string,
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
        isActive: PropTypes.func,
        isExternalUrl: PropTypes.bool,
        onClick: PropTypes.func,
        resetScroll: PropTypes.bool,
        tabIndex: PropTypes.number,
        target: PropTypes.string,
        to: PropTypes.string.isRequired
    };

    static defaultProps = {
        isExternalUrl: false,
        onClick: null
    };

    render() {
        const {
            activeClassName,
            ariaLabel,
            children,
            className,
            isActive,
            isExternalUrl,
            onClick,
            resetScroll,
            tabIndex,
            target,
            to
        } = this.props;

        if (/^[\w.]+:\/\//.test(to)) {
            const isLauncherURL = /^com\.epicgames\.launcher:\/\//.test(to);
            const linkProps = isLauncherURL
                ? {}
                : {
                      rel: 'noopener noreferrer',
                      target: target || '_blank'
                  };

            return (
                <a
                    href={to}
                    className={className}
                    aria-label={ariaLabel}
                    tabIndex={tabIndex}
                    onClick={onClick}
                    {...linkProps}>
                    {children}
                </a>
            );
        }

        if (isExternalUrl) {
            return (
                <a
                    href={generateRoutePath(to, true)}
                    aria-label={ariaLabel}
                    tabIndex={tabIndex}
                    onClick={onClick}
                    className={className}>
                    {children}
                </a>
            );
        }

        const LinkComponent = activeClassName ? NavLink : ReactRouterLink;
        const linkProps = activeClassName ? {className, isActive, activeClassName} : {className};

        return (
            <LinkComponent
                to={{pathname: generateRoutePath(to), state: {resetScroll}}}
                tabIndex={tabIndex}
                aria-label={ariaLabel}
                onClick={onClick}
                {...linkProps}>
                {children}
            </LinkComponent>
        );
    }
}

export default withRouter(Link);
